import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, ContentTemplate, KeyValue, Typography } from 'web-library';

import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { WithdrawalReviewResponse } from '../../../../api-refactored/non-national-exam-registration/useGetNonNationalExamWithdrawalReview';
import { WithdrawalSummaryResponse } from '../../../../api-refactored/non-national-exam-registration/useGetNonNationalExamWithdrawalSummary';

const useStyles = makeStyles()((theme) =>
({
  marginBottom4: {
    marginBottom: theme.spacing(4),
  },
}));

interface ReviewWithdrawalExamDetailsProps {
  withdrawalDetails: WithdrawalReviewResponse | WithdrawalSummaryResponse;
  isDividerBottom: boolean;
}

const ReviewWithdrawalExamDetails = ({
  withdrawalDetails,
  isDividerBottom,
}: ReviewWithdrawalExamDetailsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <ContentTemplate isContinuable continuous isDividerBottom={isDividerBottom}>
      <Box className={classes.marginBottom4}>
        <Typography variant="h3" className={classes.marginBottom4}>
          {t('withdrawal->>ReviewWithdrawal.ExamDetails')}
        </Typography>
        {withdrawalDetails && (
          <>
            <KeyValue
              id="examYear"
              keyText={t('withdrawal->>ReviewWithdrawal.ExamYear')}
              valueText={withdrawalDetails.examYear.toString()}
            />
            <KeyValue
              id="examLevel"
              keyText={t('withdrawal->>ReviewWithdrawal.ExamLevel')}
              valueText={withdrawalDetails.examLevel}
            />
            <KeyValue
              id="levelSeekingAdmissionTo"
              keyText={t('withdrawal->>ReviewWithdrawal.LevelSeekingAdmissionTo')}
              valueText={withdrawalDetails.levelSeekingAdmissionTo}
            />
          </>
        )}
      </Box>
    </ContentTemplate>
  );
};

export default ReviewWithdrawalExamDetails;
